import { render, staticRenderFns } from "./jsqxmList.vue?vue&type=template&id=57d61d0e&scoped=true&"
import script from "./jsqxmList.vue?vue&type=script&lang=js&"
export * from "./jsqxmList.vue?vue&type=script&lang=js&"
import style0 from "./jsqxmList.vue?vue&type=style&index=0&id=57d61d0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d61d0e",
  null
  
)

export default component.exports